import Work from "./components/work/Work";
import Home from "./home/Home";


import { BrowserRouter, Routes,Route } from "react-router-dom";

import React from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  //Menu not open by default
  
  //Passed as props
  {/**Structure
Top
Section : Intro, Portfolio, Work... testimonials */}
  return (
    <div className="app">
      
      <BrowserRouter basename="/portfolio">
      <Routes>
        <Route path="/" element={<Home/>}/>
        
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
